import { BOM } from "./definedMethod";

export default {
  //AUTHENTICATION
  Authentication: BOM.baseUrl("authentication "),
  Login: BOM.baseUrl("login", "auth"),
  ChangePassword: BOM.baseUrl("changePassword"),
  ForgotPassword: BOM.baseUrl("forgotPassword"),
  ResetPassword: BOM.baseUrl("resetPassword"),
  Refresh: BOM.baseUrl("refresh", "auth"),

  //CUSTOMER
  GetClient: BOM.baseUrl("clients"),

  //GL ACCOUNT
  GlAccount: BOM.baseUrl("glaccounts"),
  GlAccountTemplate: BOM.baseUrl("glaccounts/template"),
  NewGlAccount: BOM.baseUrl("glaccounts"),
  ApproveReject: BOM.baseUrl("glaccounts"),

  // ACCOUNTING RULES
  AccountingRules: BOM.baseUrl("accountingrules"),
  GetAccountingRulesList: BOM.baseUrl("accountingrules"),
  DetailAccountingRules: BOM.baseUrl("accountingrules"),
  AccountingRuleTemplate: BOM.baseUrl("accountingrules/template"),
  NewAccountingRules: BOM.baseUrl("accountingrules"),
  DeleteAccountingRulesList: BOM.baseUrl("accountingrules"),
  EditAccountingRule: BOM.baseUrl("accountingrules"),

  // PRODUCTS
  GetProductList: BOM.baseUrl("savingsproducts"),

  // JOURNAL ENTRY
  GetOfficeList: BOM.baseUrl("offices"),
  CurrencyList: BOM.baseUrl("currencies"),
  PaymentTypeList: BOM.baseUrl("paymenttypes"),
  GetSpecificGLList: BOM.baseUrl("glaccounts?disabled=false&usage=1"),
  // GetSpecificGLList: BOM.baseUrl("glaccounts?disabled=false&manualEntriesAllowed=true&usage=1"),
  GetJournalEntries: BOM.baseUrl(
    "journalentries?dateFormat=dd+MMMM+yyyy&limit=200&locale=en&offset=0",
  ),
  SearchJournalEntries: BOM.baseUrl("journalentries?"),
  DetailJournalEntry: BOM.baseUrl("journalentries?transactionDetails=true&transactionId"),
  NewJournalEntries: BOM.baseUrl("journalentries"),

  //GLMAPPING
  GetGLMappingList: BOM.baseUrl("financialactivityaccounts"),
  GlMappingTemplate: BOM.baseUrl("financialactivityaccounts/template"),
  NewGlMapping: BOM.baseUrl("financialactivityaccounts"),
  ViewGlMapping: BOM.baseUrl("financialactivityaccounts"),
  EditGLMappingList: BOM.baseUrl("financialactivityaccounts"),
  DeleteGLMappingList: BOM.baseUrl("financialactivityaccounts"),

  // PRODUCTS
  GetProductList: BOM.baseUrl("savingsproducts"),

  // FINANCE RULES
  GetFinanceRules: BOM.baseUrl("financialrules?offset=0"),
  DetailFinanceRules: BOM.baseUrl("financialrules"),
  EditFinanceRules: BOM.baseUrl("financialrules"),
  GetFRLocalCurrency: BOM.baseUrl("fxtransactions/localcurrency"),
  GetFREquity: BOM.baseUrl("glaccounts/bytype/equity"),
  NewFinaceRules: BOM.baseUrl("financialrules"),
  DeleteFinaceRules: BOM.baseUrl("financialrules"),
  currencies: BOM.baseUrl("currencies"),
  ApproveRejectFR: BOM.baseUrl("financialrules"),

  // END OF CIRCLES
  GetEndOfCircles: BOM.baseUrl("glclosures"),
  GetEndOfCircle: BOM.baseUrl("glclosures?officeId"),
  NewEndOfCircle: BOM.baseUrl("glclosures"),
  DetailEndOfCircle: BOM.baseUrl("glclosures"),
  DeleteEndOfCircle: BOM.baseUrl("glclosures"),
  // PERIODIC ACCRUALS
  PeriodicAccruals: BOM.baseUrl("runaccruals"),

  // FUND SOURCE
  GetFundSourceList: BOM.baseUrl("funds"),
  NewFundSource: BOM.baseUrl("funds"),
  ViewFundSource: BOM.baseUrl("funds"),
  DeleteFundSource: BOM.baseUrl("funds"),
  EditFundSource: BOM.baseUrl("funds"),

  // FREQUENT POSTING

  GetOfficesList: BOM.baseUrl("offices"),
  GetCurrenciesList: BOM.baseUrl("currencies?fields=selectedCurrencyOptions"),
  GetPaymentTypesList: BOM.baseUrl("paymenttypes"),
  AccountingRulesList: BOM.baseUrl("accountingrules?associations=all"),
  GetFrequentPostingList: BOM.baseUrl("journalentries?transactionDetails=true&transactionId"),
  FrequentPosting: BOM.baseUrl("journalentries"),

  // LOAN PRODUCT
  GetLoanProductList: BOM.baseUrl("loanproducts"),
  LoanProductTemplate: BOM.baseUrl("loanproducts/template"),
  ViewLoanProduct: BOM.baseUrl("loanproducts"),
  NewLoanProduct: BOM.baseUrl("loanproducts"),
  EditLoanProduct: BOM.baseUrl("loanproducts"),
  Charges: BOM.baseUrl("/charges"),

  // FIXED DEPOSIT
  GetFixedDepositList: BOM.baseUrl("fixeddepositproducts"),
  GetFixedDepositTemplate: BOM.baseUrl("fixeddepositproducts/template"),
  NewFixedDeposit: BOM.baseUrl("fixeddepositproducts"),
  ViewFixedDeposit: BOM.baseUrl("fixeddepositproducts"),
  EditFixedDeposit: BOM.baseUrl("fixeddepositproducts"),

  // PROVISIONING ENTRIES
  GetOfficeList: BOM.baseUrl("offices"),
  GetLoanProductList: BOM.baseUrl("loanproducts"),
  GetProvisioningcategory: BOM.baseUrl("provisioningcategory"),
  GetSpecificProvisioningList: BOM.baseUrl("provisioningentries/entries?"),
  GetProvisioningEntries: BOM.baseUrl(
    "provisioningentries?dateFormat=dd+MMMM+yyyy&limit=200&locale=en&offset=0",
  ),
  NewProvisioningEntries: BOM.baseUrl("provisioningentries"),
  DetailProvisioningEntries: BOM.baseUrl("provisioningentries"),
  DetailJournalEntries: BOM.baseUrl("journalentries/provisioning?"),
  SearchProvisioningEntries: BOM.baseUrl("provisioningentries/entries?"),

  // CASAPRODUCTS
  GetCasaProductList: BOM.baseUrl("savingsproducts"),
  DetailCasaProductList: BOM.baseUrl("savingsproducts"),
  GetTemplateProductList: BOM.baseUrl("savingsproducts/template"),
  NewCasaProductList: BOM.baseUrl("savingsproducts"),
  GetCasaProductCharges: BOM.baseUrl("/charges"),
  EditCasaProductList: BOM.baseUrl("savingsproducts"),

  //FUND MAPPING
  FundMappingTemplate: BOM.baseUrl("search/template"),
  GlAccountTemplate: BOM.baseUrl("glaccounts/template"),
  GlAccountCodeLengthConfig: BOM.baseUrl("configurations/name/gl_code_length"),
  NewGlAccount: BOM.baseUrl("glaccounts"),
  ApproveReject: BOM.baseUrl("glaccounts"),
  FundMappingSearch: BOM.baseUrl("search/advance"),

  // RECURRING DEPOSIT PRODUCTS
  GetRecurringDepositProductList: BOM.baseUrl("recurringdepositproducts"),
  DetailRecurringDepositProductList: BOM.baseUrl("recurringdepositproducts"),
  GetTemplateRecurringDepositProductList: BOM.baseUrl("recurringdepositproducts/template"),
  GetRecurringDepositProductCharges: BOM.baseUrl("/charges"),
  NewRecurringDepositProductList: BOM.baseUrl("recurringdepositproducts"),
  EditRecurringDepositProductList: BOM.baseUrl("recurringdepositproducts"),

  // FX RATE SETUP
  GetRateSetupList: BOM.baseUrl("fxrates"),
};
